export default __webpack_public_path__ + "static/media/uncommon_intel.20fbc24a.png";